module.exports = __webpack_public_path__ + "static/media/virtu.0d0f4b69.svg";